<!--
 * @FilePath: /chuanfa_jinrong_website/src/components/footer.vue
 * @Description: 底部
-->
<template>
  <div class="footer">
    <span class="copyright">©</span> 2017 传发金融信息服务有限公司 版权所有 ALL
    RIGHTS RESERVED
  </div>
</template>

<script>
export default {
  name: 'footerView'
}
</script>

<style lang="stylus">
.footer {
  width: 100%;
  height: 60px;
  background-color: #36353a;
  text-align: center;
  color: white;
  line-height: 60px;

  a {
    color: white;
    text-decoration: underline;
  }

  .copyright {
    vertical-align: bottom;
    font-size: 22px;
  }

  .copy-rights {
    img {
      width: 16px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue